import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Col, Row, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";

import { toast } from "react-toastify";
import CreateEndUserModalComponent from "./CreateEndUserModal";
import CreateOLTComponent from "../superCOO/CreateOLT";

const ModalForNewOLTCreation: React.FC<NewOLTModalProp> = ({
  handleClose,
  show,
  intPkCompanyID,
  companyName,
}) => {
  const handleApiResponse = (isSuccess: boolean) => {
    console.log({ isSuccess });
    if (isSuccess === true) {
      handleClose(true);
    }
  };
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        show={show}
        onHide={() => {
          handleClose(false);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> New OLT</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateOLTComponent
            companyName={companyName}
            intPkCompanyID={intPkCompanyID}
            handleApiResponse={handleApiResponse}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleClose(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ModalForNewOLTCreation;
